module.exports = __webpack_public_path__ + "img/19.dcedd076.jpg";